<template>
  <div>
    <!-- Spacer -->
    <div class="project-top"></div>
    <!-- Spacer / End-->

    <!-- Page Content
================================================== -->
    <div class="container py-5">
      <div class="row">
        <div class="col-xl-3 col-lg-3">
          <div class="sidebar-container  margin-top-35">
            <!-- Country -->
            <div class="sidebar-widget">
              <div class="input-with-icon">
                <div id="country-container" class="select__custom">
                  <select
                    name="country"
                    id="country"
                    v-model="countryIds"
                    @change="getRegionsInCountry()"
                  >
                    <option :value="null" selected disabled hidden
                      >Choose country</option
                    >
                    <option
                      v-for="country in countries"
                      :key="country.id"
                      :value="country.id"
                      >{{ country.name }}</option
                    >
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
            <!-- #Country -->

            <!-- Region -->
            <div class="sidebar-widget" v-if="regions && regions.length">
              <div class="input-with-icon">
                <div id="region-container" class="select__custom">
                  <select
                    name="region"
                    id="region"
                    v-model="regionIds"
                    @change="getCitiesInRegion()"
                  >
                    <option :value="null" selected disabled hidden
                      >Choose region</option
                    >
                    <option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      >{{ region.name }}</option
                    >
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
            <!-- #Region -->

            <!-- City -->
            <div class="sidebar-widget" v-if="cities && cities.length">
              <h3>City</h3>
              <div class="input-with-icon">
                <div id="city-container" class="select__custom">
                  <select name="city" id="city" v-model="cityIds">
                    <option :value="null" selected disabled hidden
                      >Choose city</option
                    >
                    <option
                      v-for="city in cities"
                      :key="city.id"
                      :value="city.id"
                      >{{ city.name }}</option
                    >
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
            <!-- #City -->

            <!-- Tasks -->
            <div class="sidebar-widget">
              <div class="input-with-icon">
                <div id="task-container" class="select__custom">
                  <select name="task" id="task" v-model="taskIds">
                    <option :value="null" selected disabled hidden
                      >Choose task</option
                    >
                    <option
                      v-for="task in tasks"
                      :key="task.id"
                      :value="task.id"
                      >{{ task.name }}</option
                    >
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
            <!-- #Tasks -->

            <!-- Expertise Types -->
            <div class="sidebar-widget">
              <h3>Select Expertise</h3>

              <div class="switches-list">
                <div
                  class="switch-container"
                  v-for="(expertise, index) in expertises"
                  :key="expertise"
                >
                  <label class="switch"
                    ><input
                      type="checkbox"
                      @change="addExperience(index)"
                    /><span class="switch-button"></span> {{ expertise }}</label
                  >
                </div>
              </div>
            </div>
            <!-- #Expertise Types -->

            <!-- Model Types -->
            <div class="sidebar-widget">
              <h3>Select Model</h3>

              <div class="switches-list">
                <div
                  class="switch-container"
                  v-for="(modChild, index) in models"
                  :key="modChild"
                >
                  <label class="switch"
                    ><input type="checkbox" @change="addModel(index)" /><span
                      class="switch-button"
                    ></span>
                    {{ capitalizeFirstLetter(modChild) }}</label
                  >
                </div>
              </div>
            </div>
            <!-- #Model Types -->

            <button
              class="button ripple-effect move-on-hover full-width margin-top-30"
              @click="applyFilter()"
            >
              <span>Apply Filter</span>
            </button>
          </div>
        </div>

        <div class="col-xl-9 col-lg-9 content-left-offset">
          <div class="intro-banner-search-form margin-top-95">
            <!-- Search Field -->
            <div class="intro-search-field">
              <label for="intro-keywords" class="field-title ripple-effect"
                >What job you want?</label
              >
              <input
                id="intro-keywords"
                type="text"
                v-model="searchTermFromUrl"
                placeholder="search projects using title, description or address"
              />
            </div>

            <!-- Button -->
            <div class="intro-search-button">
              <button class="button ripple-effect">
                Search
              </button>
            </div>
          </div>

          <!-- Projects Container -->
          <div class="tasks-list-container margin-top-35">
            <!-- Project -->
            <template v-for="(project, index) in activeProjects">
              <router-link
                class="task-listing"
                :key="index"
                :to="`/project-details?id=${project.id}`"
              >
                <!-- Project Listing Details -->
                <div class="task-listing-details">
                  <!-- Details -->
                  <div class="task-listing-description">
                    <h3 class="task-listing-title text-capitalize">
                      {{ project.title }}
                    </h3>
                    <ul class="task-icons">
                      <li>
                        <i class="icon-material-outline-location-on"></i>
                        {{ project.region ? project.region.name : "Remote" }}
                      </li>
                      <li>
                        <i class="icon-material-outline-access-time"></i>
                        Posted:
                        {{
                          project.posted_on
                            ? formatDate(project.posted_on)
                            : "Not Published"
                        }}
                      </li>
                      <li>
                        <i class="icon-line-awesome-calendar"></i> Est. Start
                        Date: {{ formatDate(project.proposed_start_date) }}
                      </li>
                      <br />
                      <li>
                        <i class="icon-line-awesome-tachometer"></i> Est.
                        Timeline: {{ project.duration }}
                      </li>
                    </ul>
                    <p class="task-listing-text">
                      {{ subString(project.description, 150) }} ...
                    </p>
                  </div>
                </div>

                <div class="task-listing-bid">
                  <div class="task-listing-bid-inner">
                    <div class="task-offers">
                      <strong>{{ formatAmount(project.budget) }}</strong>
                      <span>{{
                        project.posted_on ? "Payment verified" : ""
                      }}</span>
                    </div>
                    <span class="button button-sliding-icon ripple-effect">
                      View
                      <i class="icon-material-outline-arrow-right-alt"></i
                    ></span>
                  </div>
                </div>
              </router-link>
            </template>

            <!-- Pagination -->
            <div class="clearfix"></div>
            <h3 class="page-title">{{ totalProjects }} Results</h3>
            <div class="row ">
              <div class="col-md-12 d-flex justify-content-center">
                <!-- Projects -->
                <div
                  class="pagination-container margin-top-30 margin-bottom-60"
                >
                  <nav class="pagination">
                    <ul>
                      <li
                        class="pagination-arrow"
                        :class="[prevPageUrl === null ? 'isDisabled' : '']"
                      >
                        <a href="#" class="ripple-effect" @click="getPrevPage()"
                          ><i
                            class="icon-material-outline-keyboard-arrow-left"
                          ></i
                        ></a>
                      </li>

                      <li v-for="index in paginationTotal" :key="index">
                        <a
                          href="#"
                          v-on="
                            isSearching
                              ? { click: () => applyFilter(index) }
                              : { click: () => getActiveProjects(index) }
                          "
                          class="ripple-effect"
                          :class="[currentPage === index ? 'current-page' : '']"
                          >{{ index }}</a
                        >
                      </li>
                      <li
                        class="pagination-arrow "
                        :class="[nextPageUrl === null ? 'isDisabled' : '']"
                      >
                        <a href="#" class="ripple-effect" @click="getNextPage()"
                          ><i
                            class="icon-material-outline-keyboard-arrow-right"
                          ></i
                        ></a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <!-- Pagination / End -->
          </div>
          <!-- Projects Container / End -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { getCall, postCall } from "../../../core/services/http.service";
import {
  ACTIVE_PROJECTS,
  PROJECT_ATTRIBUTES,
  SEARCH_PROJECTS,
} from "../../../core/config/endpoints/projects";
import {
  COUNTRIES,
  REGIONS_IN_COUNTRY,
  CITIES_IN_REGION,
} from "../../../core/config/endpoints/location";
import { ALL_TASKS } from "../../../core/config/endpoints/tasks";
import {
  subString,
  formatDate,
  capitalizeFirstLetter,
  formatAmount,
} from "../../../plugins/handlers";

export default {
  name: "Projects",
  components: {},
  data() {
    return {
      searchTermFromUrl: "",
      activeProjects: [],
      currentPage: 1,
      firstPageUrl: "",
      nextPageUrl: "",
      prevPageUrl: "",
      paginationTotal: 0,
      itemsPerPage: 0,
      totalProjects: 0,
      activeProjectsUrl: ACTIVE_PROJECTS,
      projectAttributes: {},
      tasks: [],
      countries: [],
      regions: [],
      cities: [],
      expertises: [],
      models: [],
      cityIds: null,
      modelId: [],
      taskIds: null,
      filter: {},
      model: [],
      countryIds: null,
      regionIds: null,
      experience: [],
      isSearching: false,
    };
  },

  computed: {
    // searchTermFromUrl() {
    //   return this.$route.query.searchTerm;
    // },
  },

  methods: {
    formatAmount(amount) {
      return formatAmount(amount);
    },

    searchProjects(page = false) {
      this.$store.commit("setIsLoaded", true);
      let url = page ? `${SEARCH_PROJECTS}?page=${page}` : SEARCH_PROJECTS;

      let searchObject = {};
      if (this.searchTermFromUrl && this.searchTermFromUrl.length > 3)
        searchObject.description = this.searchTermFromUrl;

      postCall(url, searchObject)
        .then(response => {
          this.activeProjects = response.data.data.data;
          this.firstPageUrl = response.data.data.first_page_url;
          this.nextPageUrl = response.data.data.next_page_url;
          this.prevPageUrl = response.data.data.prev_page_url;
          this.totalProjects = response.data.data.total;
          this.itemsPerPage = response.data.data.per_page;
          this.currentPage = response.data.data.current_page;
          this.getPaginationTotal();
        })
        .catch(error => {
          this.$store.commit("setNotify", {
            type: "error",
            message: error.response.data.message,
            status: true,
          });
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getActiveProjects(pageNumber = false) {
      this.$store.commit("setIsLoaded", true);
      pageNumber = pageNumber ? pageNumber : this.currentPage;
      this.isSearching = false;
      getCall(`${ACTIVE_PROJECTS}?page=${pageNumber}`)
        .then(response => {
          this.activeProjects = response.data.data.data;
          this.firstPageUrl = response.data.data.first_page_url;
          this.nextPageUrl = response.data.data.next_page_url;
          this.prevPageUrl = response.data.data.prev_page_url;
          this.totalProjects = response.data.data.total;
          this.itemsPerPage = response.data.data.per_page;
          this.currentPage = response.data.data.current_page;
          this.getPaginationTotal();
        })
        .catch(error => {
          console.log(error.response.data.message);

          this.$store.commit("setNotify", {
            type: "error",
            message: error.response.data.message,
            status: true,
          });
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getAllTasks() {
      this.$store.commit("setIsLoaded", true);
      getCall(`${ALL_TASKS}`)
        .then(response => {
          this.tasks = response.data.data;
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("setNotify", {
            type: "error",
            message: error.response.data.message,
            status: true,
          });
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getProjectAttributes() {
      this.$store.commit("setIsLoaded", true);
      getCall(`${PROJECT_ATTRIBUTES}`)
        .then(response => {
          this.expertises = response.data.data.expertise;
          this.models = response.data.data.model;
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("setNotify", {
            type: "error",
            message: error.data,
            status: true,
          });
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getAllCountries() {
      this.$store.commit("setIsLoaded", true);
      getCall(`${COUNTRIES}`)
        .then(response => {
          this.countries = response.data.data;
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("setNotify", {
            type: "error",
            message: error.response.data.message,
            status: true,
          });
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getRegionsInCountry() {
      getCall(`${REGIONS_IN_COUNTRY}${this.countryIds}`)
        .then(response => {
          this.regions = response.data.data;
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {});
    },

    getCitiesInRegion() {
      getCall(`${CITIES_IN_REGION}${this.regionIds}`)
        .then(response => {
          this.cities = response.data.data;
        })
        .catch(error => {
          this.$store.commit("setNotify", {
            type: "error",
            message: error.response.data.message,
            status: true,
          });
        })
        .finally(() => {});
    },

    applyFilter(pageNumber = false) {
      this.isSearching = true;
      this.$store.commit("setIsLoaded", true);
      let searchQuery = {};

      if (this.countryIds) {
        searchQuery.countryIds = [this.countryIds];
      }
      if (this.regionIds) {
        searchQuery.regionIds = [this.regionIds];
      }
      if (this.model.length) {
        searchQuery.model = this.model;
      }
      if (this.experience.length) {
        searchQuery.experience = this.experience;
      }
      if (this.taskIds) {
        searchQuery.taskIds = [this.taskIds];
      }

      if (this.cityIds) {
        searchQuery.cityIds = [this.cityIds];
      }

      pageNumber = pageNumber ? pageNumber : this.currentPage;
      postCall(`${SEARCH_PROJECTS}?page=${pageNumber}`, searchQuery)
        .then(response => {
          this.activeProjects = response.data.data.data;
          this.firstPageUrl = response.data.data.first_page_url;
          this.nextPageUrl = response.data.data.next_page_url;
          this.prevPageUrl = response.data.data.prev_page_url;
          this.totalProjects = response.data.data.total;
          this.itemsPerPage = response.data.data.per_page;
          this.currentPage = response.data.data.current_page;
          this.getPaginationTotal();
        })
        .catch(error => {
          console.log(error.response.data.message);
          this.$store.commit("setNotify", {
            type: "error",
            message: error.response.data.message,
            status: true,
          });
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    addExperience(expertise) {
      if (this.experience.includes(expertise)) {
        let experienceIndex = this.experience.indexOf(expertise);
        return this.experience.splice(experienceIndex, 1);
      }
      return this.experience.push(expertise);
    },
    addModel(modelId) {
      if (this.model.includes(modelId)) {
        let modelIndex = this.model.indexOf(modelId);
        return this.model.splice(modelIndex, 1);
      }
      return this.model.push(modelId);
    },
    getPrevPage() {
      this.currentPage--;
      return this.isSearching ? this.applyFilter() : this.getActiveProjects();
    },

    getNextPage() {
      this.currentPage++;
      return this.isSearching ? this.applyFilter() : this.getActiveProjects();
    },

    subString(string, length) {
      return subString(string, length);
    },

    formatDate(dateTime) {
      return formatDate(dateTime);
    },
    capitalizeFirstLetter(string) {
      return capitalizeFirstLetter(string);
    },

    getPaginationTotal() {
      this.paginationTotal = Math.ceil(this.totalProjects / this.itemsPerPage);
    },

    viewProject(project) {
      if (!project.posted_on) return;
      this.$store.commit("setProjectDetails", project);
      this.$router.push({
        name: "ProjectDetails",
        query: { id: `${project.id}` },
      });
    },
  },

  mounted() {
    this.searchTermFromUrl = this.$route.query.searchTerm;
    this.searchProjects();
    // this.getActiveProjects();
    this.getAllCountries();
    this.getProjectAttributes();
    this.getAllTasks();
  },
};
</script>

<style scoped>
.pagination ul li + li {
  margin-left: 5px !important;
}

.isDisabled {
  color: currentColor !important ;
  cursor: not-allowed !important ;
  opacity: 0.5 !important ;
  text-decoration: none !important ;
  pointer-events: none !important ;
}

.isDisabled > li {
  color: currentColor;
  display: inline-block; /* For IE11/ MS Edge bug */
  pointer-events: not-allowed;
  text-decoration: none;
}
</style>
<style></style>
